import React from 'react'
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core'
import { useTrans } from '../../../../services/i18n'
import { ANY_OF_THOSE } from '../../../../constants/filter'
import connect from '../connect'

const StatusDropdown = ({ filters, onChangeFilters }) => {
  const { trans } = useTrans()

  const statusOptions = [
    { name: 'All statuses', value: ['new', 'progress', 'completed'] },
    { name: 'New', value: ['new'] },
    { name: 'In Progress', value: ['progress'] },
    { name: 'Completed', value: ['completed'] },
  ]

  const currentValue = filters?.fields?.adminStatus?.value || []
  const selectedOption = statusOptions.find(option =>
    JSON.stringify([...option.value].sort()) === JSON.stringify([...currentValue].sort())
  ) || statusOptions[0]

  const handleChange = (event) => {
    const selectedValue = event.target.value
    const option = statusOptions.find(opt => JSON.stringify(opt.value) === selectedValue)

    if (option) {
      onChangeFilters({
        adminStatus: {
          type: ANY_OF_THOSE,
          value: option.value,
        },
      })
    }
  }

  return (
    <FormControl style={{ minWidth: 150 }}>
      <InputLabel>{trans('status')}</InputLabel>
      <Select
        value={JSON.stringify(selectedOption.value)}
        onChange={handleChange}
      >
        {statusOptions.map(option => (
          <MenuItem key={option.name} value={JSON.stringify(option.value)}>
            {trans(option.name.toLowerCase().replace(' ', '-')) || option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default connect(StatusDropdown)
